<script setup lang="ts">
  import type { PropType } from 'vue'

  import type { HLTagColor, HLTagSize } from '@platform-ui/highrise'
  import { HLTag } from '@platform-ui/highrise'

  const props = defineProps({
    id: {
      type: String,
      default: undefined,
    },
    size: {
      type: String as PropType<HLTagSize>,
      default: undefined,
    },
    color: {
      type: String as PropType<HLTagColor>,
      default: undefined,
    },
    bordered: {
      type: Boolean,
      default: undefined,
    },
    round: {
      type: Boolean,
      default: undefined,
    },
    closable: {
      type: Boolean,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: undefined,
    },
    interactive: {
      type: Boolean,
      default: undefined,
    },
    truncate: {
      type: Boolean,
      default: undefined,
    },
    count: {
      type: Number,
      default: undefined,
    },
    maxWidth: {
      type: [String, Number],
      default: undefined,
    },
  })

  defineOptions({ name: 'CPTag', inheritAttrs: false })
</script>

<template>
  <HLTag
    v-bind="$attrs"
    :id="props.id"
    :size="props.size"
    :color="props.color"
    :bordered="props.bordered"
    :round="props.round"
    :closable="props.closable"
    :disabled="props.disabled"
    :interactive="props.interactive"
    :truncate="props.truncate"
    :count="props.count"
    :max-width="props.maxWidth"
  >
    <template v-if="$slots.icon || $slots.suffix" #icon>
      <slot name="icon" />
      <slot name="suffix" />
    </template>
    <template v-if="$slots.avatar" #avatar>
      <slot name="avatar" />
    </template>
    <slot />
  </HLTag>
</template>
